import { styled } from "styled-components";

import { DigitalMemberTag, Image, UIIconButton } from "common/components";
import { breakpoints } from "common/styles";
import { useElementIsLoaded } from "common/utilities";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";
import MapImage from "domains/landing/topics/map-image.png";
import { interpolate } from "domains/language/interpolate";
import { getShouldShowBecomeMemberMarketing } from "entities/permissions/selectors";

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
`;

const StyledContainer = styled.div`
  display: flex;
  max-width: 1600px;
  flex-direction: column;
  margin: 2rem;

  @media ${breakpoints.medium} {
    margin: 2rem 4rem;
  }

  @media ${breakpoints.large} {
    flex-direction: row;
  }
`;

const StyledLeftContainer = styled.div``;

const StyledRightContainer = styled(StyledLeftContainer)<{ isLoaded: boolean }>`
  padding-top: 1rem;
  transition: opacity 1s ease-in-out;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
  display: flex;
  flex-direction: column;
`;

const StyledTMVisual = styled(Image)`
  width: 100%;
  display: none;
  height: 300px;
  object-fit: contain;

  @media ${breakpoints.medium} {
    display: block;
    padding: 1rem 1rem 1rem 0;
  }

  @media ${breakpoints.large} {
    width: 300px;
  }
`;

const StyledTitle = styled(StyledLandingTitle)<{ isLoaded: boolean }>`
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
`;

const StyledText = styled(StyledLandingText)<{ isLoaded: boolean }>`
  transition: opacity 0.3s ease-in-out 0.3s;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
`;

const StyledDigitalMemberTag = styled(DigitalMemberTag)`
  display: inline-block;
  transform: scale(0.7);
  margin: 0 -20px 0 -30px;
`;

export const TransformationMapSection = () => {
  const { isLoaded, elementRef } = useElementIsLoaded(0.2);
  const showAdvancedMap = useSelector(getShouldShowBecomeMemberMarketing);
  const translate = useTranslate();

  return (
    <StyledOuterContainer ref={elementRef}>
      <StyledContainer>
        <StyledLeftContainer>
          <StyledTMVisual src={MapImage} alt={translate("app.settings.about.about_transformation_map")} />
        </StyledLeftContainer>
        <StyledRightContainer isLoaded={isLoaded}>
          <StyledTitle isLoaded={isLoaded}>{translate("app.transformation_map.title")}</StyledTitle>
          {showAdvancedMap ? (
            <>
              <StyledText isLoaded={isLoaded}>{translate("app.transformation_map.info_text")}</StyledText>
              <StyledText isLoaded={isLoaded}>
                {interpolate(translate("app.transformation_map.advanced_map.info_text"), {
                  digitalMembership: () => (
                    <StyledDigitalMemberTag trackPage="Landing" text={translate("app.membership.pro")} />
                  ),
                })}
              </StyledText>
            </>
          ) : (
            <StyledText isLoaded={isLoaded}>{translate("app.transformation_map.info_text_long")}</StyledText>
          )}
          <UIIconButton as="a" href="/topics" icon="rightArrow" variant="filled">
            {translate("app.discover_topics.title")}
          </UIIconButton>
        </StyledRightContainer>
      </StyledContainer>
    </StyledOuterContainer>
  );
};
